import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalConfig } from './auth';
import { FluentProvider, teamsLightTheme } from '@fluentui/react-components';

/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders. 
 * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
const msalInstance = new PublicClientApplication(MsalConfig);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <FluentProvider theme={teamsLightTheme}>
      <App instance={msalInstance}/>
    </FluentProvider>
  </React.StrictMode>
);
